import React, { Component } from 'react';
import {
  GECKO_CONSTS,
  GeckoModal,
  GeckoFields,
  GeckoTable,
  GeckoModalService,
  GeckoToastService,
} from 'ui';
import GeckoRequest from 'services/gecko-request';
import GeckoLocation from 'services/gecko-location';
import Loader from 'components/Loader';
import { renderError } from 'services/gecko-error';
import { connect } from 'react-redux';

class CloneBotModal extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      bots: [],
      botToClone: null,
      responsesToClone: [],
      responses: [],
      fetchingResponses: false,
    };
  }

  componentDidMount() {
    GeckoRequest.get('/bots', { page: 1 }).then(({ data }) => {
      this.setState({ bots: data });
    });
  }

  botToCloneField() {
    return [
      {
        label: 'Which Bot would you like to clone?',
        key: 'botToClone',
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        width: '100',
        options: this.state.bots.map((bot) => {
          return {
            label: bot.name,
            value: bot.id,
          };
        }),
      },
      {
        label: `Which answers should we clone?`,
        key: 'responses_to_clone',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        hideWhen: () => !this.state.botToClone,
        width: '100',
        component: (
          <Loader isLoading={this.state.fetchingResponses}>
            <GeckoTable
              rows={this.state.responses}
              cols={this.responsesToCloneCols()}
              rowHandler={this.toggleResponse.bind(this)}
            />
          </Loader>
        ),
      },
    ];
  }

  botToCloneHandler(_key, value) {
    this.setState(
      {
        botToClone: value,
        fetchingResponses: true,
        responses: [],
        responsesToClone: [],
      },
      () => {
        if (this.state.botToClone) {
          return GeckoRequest.get(`/bots/${this.state.botToClone}/answers`, {
            all: true,
          }).then((res) => {
            this.setState({ responses: res.data, fetchingResponses: false });
          });
        } else {
          this.setState({ fetchingResponses: false });
        }
      }
    );
  }

  toggleResponse(response) {
    const checked = this.state.responsesToClone.includes(response.id);
    if (checked) {
      return this.setState({
        responsesToClone: this.state.responsesToClone.filter(
          (responseId) => responseId !== response.id
        ),
      });
    }
    return this.setState({
      responsesToClone: this.state.responsesToClone.concat(response.id),
    });
  }

  responsesToCloneCols() {
    const allChecked =
      this.state.responses.length &&
      this.state.responses.filter(
        (response) => !this.state.responsesToClone.includes(response.id)
      ).length === 0;
    const toggleCheckAll = () => {
      if (allChecked) {
        return this.setState({ responsesToClone: [] });
      }
      return this.setState({
        responsesToClone: this.state.responses.map((response) => response.id),
      });
    };
    return [
      {
        key: 'should_clone',
        name: (
          <input
            type="checkbox"
            checked={allChecked}
            onChange={toggleCheckAll}
          />
        ),
        render: (_, response) => {
          const checked = this.state.responsesToClone.includes(response.id);
          const toggle = () => {
            if (checked) {
              return this.setState({
                responsesToClone: this.state.responsesToClone.filter(
                  (responseId) => responseId !== response.id
                ),
              });
            }
            return this.setState({
              responsesToClone: this.state.responsesToClone.concat(response.id),
            });
          };
          return <input type="checkbox" checked={checked} onChange={toggle} />;
        },
      },
      {
        key: 'name',
        name: 'Name',
        width: '100%',
      },
    ];
  }

  footerBtns = [
    {
      type: 'primary',
      name: 'Clone',
      icon: 'far fa-copy',
      disabledWhen: () => {
        return !this.state.botToClone || !this.state.responsesToClone.length;
      },
      handler: () => {
        return GeckoRequest.post(`/bots/${this.state.botToClone}/clone`, {
          responses: this.state.responsesToClone,
        })
          .then((bot) => {
            new GeckoToastService().success('Bot has been cloned');
            new GeckoModalService().close();
            return GeckoLocation.goTo(`/bots/${bot.id}/settings`);
          })
          .catch(renderError);
      },
    },
  ];

  render() {
    return (
      <div className="CloneBotModal">
        <GeckoModal name="Clone Bot" btns={this.footerBtns}>
          <GeckoFields
            fields={this.botToCloneField()}
            values={this.state}
            handler={this.botToCloneHandler.bind(this)}
          />
        </GeckoModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bots: state.bots,
  };
};

export default connect(mapStateToProps)(CloneBotModal);
